<template>
  <div class="chat">
    <div class="content">
      <h2 class="chat-title">Chat</h2>
      <ul class="chat-messages no-scrollbar" id="chat-msgs">
        <li v-for="msg in chat_msgs" :key="msg.id">
          <span class="msg-name">{{ msg.name }}</span> {{ msg.text }}
        </li>
      </ul>
      <div class="chat-input">
        <input
          type="text"
          placeholder="your space id (max 20 chars)"
          v-model="chat_name"
          required
          maxlength="20"
        />

        <div v-if="!loading">
          <textarea
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="your message to the world (press return to send, max 250chars)"
            @keyup.enter="sendChatMsg"
            v-model="chat_msg"
            required
            maxlength="250"
          ></textarea>
        </div>

        <div v-else>
          <Loader2></Loader2>
        </div>

        <button
          style="margin-left: 40%;"
          @click="sendChatMsg"
          :disabled="loading"
        >
          send
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";
import Loader2 from "@/components/utilities/Loader2";
export default {
  name: "Chat",
  components: {
    Loader2,
  },
  data() {
    return {
      chat_msgs: [],
      chat_name: "",
      chat_msg: "",
      loading: false,
    };
  },
  firebase: {
    chat_msgs: db.ref("chat_msgs"),
  },
  created() {
    if (typeof localStorage.kizi404_chatName !== "undefined")
      this.chat_name = localStorage.kizi404_chatName;
  },
  async mounted() {
    while (this.chat_msgs.length == 0) {
      await new Promise((r) => setTimeout(r, 500));
    }
    this.scrollingDownChat();
  },
  methods: {
    sendChatMsg() {
      if (this.validateChat()) {
        this.loading = true;
        db.ref("chat_msgs")
          .push({
            name: this.chat_name,
            text: this.chat_msg,
          })
          .then(() => {
            this.chat_msg = "";
            if (
              typeof localStorage.kizi404_chatName == "undefined" ||
              localStorage.kizi404_chatName == "" ||
              localStorage.kizi404_chatName !== this.chat_name
            )
              localStorage.kizi404_chatName = this.chat_name;
            setTimeout(() => {
              this.scrollingDownChat();
              this.loading = false;
            }, 1000);
          });
      }
    },
    validateChat() {
      if (this.chat_name !== "" && this.chat_msg !== "") {
        return true;
      }
    },
    scrollingDownChat() {
      var elem = document.getElementById("chat-msgs");
      elem.scrollTop = elem.scrollHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat {
  position: absolute;
  top: 3vh;
  right: 1vw;
  width: 40vw;
  height: 97vh;
  background-image: url("../../assets/medias/images/chat_scroll.png");
  background-size: 100% 100%;
  color: rgb(49, 42, 42);
}

ul {
  padding-left: 0;
}

li {
  list-style: none;
  padding: 4px;
}

.chat-title {
  text-align: center;
  margin-top: 10%;
}

.chat .content {
  padding: 15%;
  padding-left: 20%;
  padding-right: 20%;
}

.chat-messages {
  font-size: 1.3rem;
  height: 30vh;
  overflow-y: scroll;
}

::placeholder {
  color: $light-grey;
  font-family: $font-stack;
  font-size: 1.3rem;
}

input,
textarea {
  border: groove;
  padding: 0;
  width: 100%;
  height: 1.5rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  font: $font-stack 1.5rem;
  margin-bottom: 10px;
}

textarea {
  height: 13vh;
}

.msg-name {
  border-radius: 2px;
  padding: 2px;
  border: black 1px solid;
}

@media screen and (max-width: 900px) and (max-height: 600px) {
  .chat-messages,
  ::placeholder {
    font-size: 2vw;
    margin-bottom: 1vh;
  }
  h2 {
    margin-bottom: 3vh;
  }
  input {
    height: 5vh;
  }
}

@media screen and (min-width: 750px) and (max-height: 600px) {
  input,
  textarea,
  .chat,
  ::placeholder {
    font-size: 1rem;
  }
}
</style>
